import { render, staticRenderFns } from "./VirtualKeyboard.vue?vue&type=template&id=643c39cc&scoped=true&"
import script from "./VirtualKeyboard.vue?vue&type=script&lang=js&"
export * from "./VirtualKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./VirtualKeyboard.vue?vue&type=style&index=0&id=643c39cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643c39cc",
  null
  
)

export default component.exports